// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"254":"56c12eb5","638":"2f53cf9a"}[chunkId] || chunkId) + "." + {"62":"112063bb9214593e","254":"a8d980bd4184bedc","482":"4e5147fe2fe0d502","638":"67cb88e36b3adb50","791":"9657290bc34aad8d","941":"ca2d5b00dc78d74a"}[chunkId] + ".js";
};